import ApiService from '@/services/ApiService';

export default class ChildrenApiService extends ApiService {
    constructor() {
        super('children');
    }
}
